<template>
  
  <div class="survey">    
    <div class="grid mt-1">
      <div class="cell">
        <div class="has-text-centered white-bkg">
          <p> <img src="../assets/logoalma.png"> </p>
        </div>
      </div>
    </div>
    
    <div class="grid mt-1 has-4-cols" v-if="ready == false">
      <div class="cell"></div>
      <div class="cell">
        <div class="has-text-centered"> 
          <progress class="progress is-large is-info" max="100"> </progress> 
        </div>
      </div>
      <div class="cell"></div>
    </div>
    
    <div v-if="ready">
      <div class="grid mt-1">
        <div class="cell">
          <div class="has-text-centered" v-if="foundFeedbacks == true">
            <p> {{  $t('FillInstruction.p_1')  }} </p>
            <p> {{  $t('FillInstruction.p_2')  }} </p>
          </div>
          <div class="has-text-centered" v-if="foundFeedbacks == false">
            <p> {{  $t('NoFeedbackMsg')  }} </p>
          </div>
        </div>
      </div>
      
      <div class="grid mt-1" v-for="feedback in listFeedback" v-bind:key="feedback.Id">
        <div class="cell">
          <div class="is-size-10">
            <div class="question-header has-text-centered">
              <div> {{ feedback.Survey_Collector__r.Materia__r.Name }} - {{ feedback.Survey_Collector__r.Docente__r.Name }}  </div>
            </div>
            
            <div> 
              <div class="has-text-centered">
                <img src="/icons/face_frown.png" class="icon-large spacer-right"  />
                <img src="/icons/star_full.png" class="icon-large small-spacer" v-for="n in feedback.Rating__c" v-bind:key="feedback.Id + '_FS' + n" v-on:click="setRating(feedback, n, 'fs')" />
                <img src="/icons/star_empty.png" class="icon-large small-spacer" v-for="n in numEmptyStars(feedback)" v-bind:key="feedback.Id + '_ES' + n" v-on:click="setRating(feedback, n, 'es')" />
                <img src="/icons/face_smile.png" class="icon-large spacer-left"  />
              </div>
            </div>
            
            <div class="has-text-centered mt-3">
              <div class="formfield">
                <label v-bind:for="'textarea_' + feedback.Id" class="notes valign-top"> {{ $t('Note') }}: </label>
                <textarea v-bind:id="'textarea_' + feedback.Id" class="c-width_75" rows="2" maxlength="255" v-model="feedback.Message__c"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="grid" v-if="listFeedback && listFeedback.length > 0">
        <div class="cell">
          <div class="has-text-centered">
            <button class="button is-success" v-on:click="submitFeedbacks()"> {{ $t('Submit') }} </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>


<script>
import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'

export default {
  name: 'Survey',
  mixins: [gnetMixLib],
  components: {
  },
  
  props: {
    recordid: String,
  },
  
  data: function() {
    return {
      retry: true,
      ready: false,
      listFeedback: []
    };
  },
  
  watch: { },
  
  computed: {
    foundFeedbacks: function() {
      return this.listFeedback && this.listFeedback.length > 0;
    }
  },
  
  created: async function() { },
  
  mounted: async function() {
    const urlParams = new URLSearchParams(window.location.search);
    let queryStringId = '';
    if(urlParams.has('sid')) {
      queryStringId = urlParams.get('sid');        
    }
    
    await this.$store.dispatch('sleeper', { millis: 1000 })
    
    this.recordId = (this.recordId) ? this.recordId : queryStringId;
    this.startOpenReplay({ userID: this.recordId });
    
    await this.init();
  },
  
  methods: {
    init: async function() {
      window.OpenReplay.setMetadata('studentId', this.recordId);        
      
      if(this.recordId && this.recordId.length >= 15) {
        let student = await this.getStudent(this.recordId);
        if(student && student.Id) {    
          this.setOpenReplayUserID({userID: student.Email__c});
          window.OpenReplay.setMetadata('studentEmail', student.Email__c);

        
          this.listFeedback = await this.getFeedbacks(student);

          if(this.listFeedback.length == 0) { window.OpenReplay.issue('feedbacks_notFound', { success: false }); }
        } else {
          window.OpenReplay.issue('student_notFound', { data: student });
        }
      }

      if(this.listFeedback.length == 0 && this.retry == true) {
        setTimeout(() => { 
          this.retry = false; 
          this.init(); 
        }, 1000);
      } else {
        
        window.OpenReplay.setMetadata('feedbacksCounter', this.listFeedback.length);
        window.OpenReplay.setMetadata('codiceCorso', (this.listFeedback.length > 0) ? this.listFeedback[0].Codice_Corso_Formula__c : '-');

        this.ready = true;
      }
    },
    
    getStudent: async function(recordId) {
      let query = `SELECT Id, Name, Key__c, Email__c FROM HP_Studente__c WHERE Id = '${recordId}'`;
      try {
        let res = await apiclient.query(recordId, query);
        if(res && res.data && res.data.length > 0) { 
          return res.data[0]; 
        }
      } catch(err) {
        console.error(err);
      }
      
      return undefined;
    },
    
    getFeedbacks: async function(student) {
      let select = ` SELECT Id, Rating__c, Message__c, isAnswered__c, Codice_Corso_Formula__c, Student__c, Student__r.Name, Student__r.Key__c, Student__r.Email__c, Survey_Collector__c, `;
      select += ` Survey_Collector__r.Materia__r.Name, Survey_Collector__r.Docente__r.Name FROM Feedback__c `;
      let where = ` WHERE Need_To_Be_Filled__c = TRUE AND Student__c = '${student.Id}' AND Survey_Collector__r.Open_Date__c	<= TODAY AND Survey_Collector__r.Close_Date__c	>= TODAY`;
      if(this.$store.getters.isSandbox) {
        where = ` WHERE Need_To_Be_Filled__c = TRUE AND Student__c = '${student.Id}' AND Survey_Collector__r.Open_Date__c	<= TODAY AND Survey_Collector__r.Close_Date__c	>= TODAY`;
      }
      
      let res = await apiclient.query(student.Id, select + where);
      if(res && res.data && res.data.length > 0) {
        return res.data;
      }
      
      return [];
    },
    
    numEmptyStars: function(feedback) {
      let fullVote = 10;
      let actualVote = feedback.Rating__c ? feedback.Rating__c : 0;
      return (fullVote - actualVote);
    },
    
    setRating: function(feedback, clickedStarNumber, starType) {
      let currentVote = feedback.Rating__c ? feedback.Rating__c : 0;
      let newVote = (starType == 'fs') ? clickedStarNumber : currentVote + clickedStarNumber;
      feedback.Rating__c = newVote;
      feedback.isAnswered__c = true;
    },
    
    submitFeedbacks: async function() {
      window.OpenReplay.setMetadata('submitBtnPressed', 'true');
      window.OpenReplay.event('submit_button', { pressed: true });

      let listUnanswered = this.listFeedback.filter(function(feedback) {
        return feedback.isAnswered__c == false;
      })
      
      if(listUnanswered && listUnanswered.length > 0) {
        alert(this.$t('Err_Unfilled'));
        return;
      }
      
      let mapCallError = {};
      for(let feedback of this.listFeedback) {
        if(feedback.isAnswered__c == false) continue;

        // - remove fields that cannot be updated - 
        delete feedback.Codice_Corso_Formula__c;

        let res = await apiclient.update(this.recordid, 'Feedback__c', feedback.Id, feedback);
        if(res.error) {
          mapCallError[feedback.Id] = res;
        }
      }
      
      if(Object.keys(mapCallError).length > 0) {
        alert('error occured');
        window.OpenReplay.issue('operation_failed', { success: false });
        console.log(JSON.stringify(mapCallError));
        this.init();
        return;
      }
      
      window.OpenReplay.issue('operation_done', { success: true });
      window.OpenReplay.setMetadata('operationDone', 'true');
      
      this.$router.push({ name: 'typage', params: { fromSurvey: true } });
    },
    
    setOpenReplayUserID(options) {
      window.OpenReplay.setUserID(options.userID);
      
      setInterval(() => {
        window.OpenReplay.setUserID(options.userID);
      }, 1000);
    },
    
    startOpenReplay(options) {
      console.log('startOpenReplay');
      let startOpts = { userID: options.userID };
      let initOpts = {
        projectKey: "oQGud8xN5sTsWR1AQuFc",
        ingestPoint: "https://session.gnet.it/ingest",
        defaultInputMode: 2,
        obscureTextNumbers: false,
        obscureTextEmails: true,
      };
      
      (function(A,s,a,y,e,r){
        r=window.OpenReplay=[e,r,y,[s-1, e]];
        s=document.createElement('script');s.src=A;s.async=!a;
        document.getElementsByTagName('head')[0].appendChild(s); // eslint-disable-next-line no-unused-vars
        r.start=function(v){r.push([0])}; // eslint-disable-next-line no-unused-vars
        r.stop=function(v){r.push([1])};
        r.setUserID=function(id){r.push([2,id])};
        r.setUserAnonymousID=function(id){r.push([3,id])};
        r.setMetadata=function(k,v){r.push([4,k,v])};
        r.event=function(k,p,i){r.push([5,k,p,i])};
        r.issue=function(k,p){r.push([6,k,p])};
        r.isActive=function(){return false};
        r.getSessionToken=function(){};
      })("//static.openreplay.com/16.0.1/openreplay.js",1,0,initOpts,startOpts);
    }
  },
}

</script>

<style scoped>

.question-header {
  margin-top: 10px;
  margin-bottom: 5px;
  font-weight: bold;
}


.spacer-right {
  margin-right: 2.5vw;
}

.spacer-left {
  margin-left: 2.5vw;
}

.small-spacer {
  margin-right: 0.1rem;
  margin-left: 0.1rem;
}

.notes {
  white-space: nowrap;
  margin-right: 0.1rem;
}

.valign-top {
  vertical-align: top;
}

.c-width_75 {
  width: 80vw;
}

.icon-large {
  width: 7vw;
  max-width: 4rem;
}

.white-bkg {
  background: white;
}

</style>

